var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSupplementsHeroArrow = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 49,
    viewBox: "0 0 37 49",
    width: 37,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.684 18.405L28.623 41.711 5.316 41.772",
    transform: "translate(-22 -772) translate(23.5 772.5) rotate(45 17 30.088)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 46.5L17 0.5",
    transform: "translate(-22 -772) translate(23.5 772.5)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSupplementsHeroArrow);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjQ5IiB2aWV3Qm94PSIwIDAgMzcgNDkiIHdpZHRoPSIzNyI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsUnVsZT0iZXZlbm9kZCIgc3Ryb2tlTGluZWNhcD0icm91bmQiPgogICAgICAgIDxnIHN0cm9rZVdpZHRoPSIyIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8cGF0aAogICAgICAgICAgICAgICAgZD0iTTI4LjY4NCAxOC40MDVMMjguNjIzIDQxLjcxMSA1LjMxNiA0MS43NzIiCiAgICAgICAgICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIgLTc3MikgdHJhbnNsYXRlKDIzLjUgNzcyLjUpIHJvdGF0ZSg0NSAxNyAzMC4wODgpIgogICAgICAgICAgICAgICAgLz4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNyA0Ni41TDE3IDAuNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIyIC03NzIpIHRyYW5zbGF0ZSgyMy41IDc3Mi41KSIgLz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";